import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import LanguageSelector from "./LanguageSelector";

export default function NeokittyLanding() {
  const { t, i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("i18nextLng")) {
      i18n.changeLanguage("en").catch(() => {});
    }
  }, [i18n]);

  const lang = i18n.language || "en";
  const gameHref = lang === "en" ? "/game" : `/${lang}/game`;
const menuBtn =
    "relative px-3 py-2 text-base font-semibold tracking-wide text-white/80 transition-all duration-300 hover:text-white after:absolute after:left-1/2 after:-bottom-1 after:h-[2px] after:w-0 after:bg-[#00E6FF] after:rounded-full after:transition-all after:duration-300 hover:after:w-[60%] hover:after:left-1/5";

  const presalePercent = 0;

  /* ---------- SEO DINÁMICO ---------- */
  const seoTitle =
    lang === "en"
      ? "Neokitty (NKTT) | Gaming Token on Base Chain"
      : lang === "es"
      ? "Neokitty (NKTT) | Token Gaming en Base Chain"
      : lang === "ru"
      ? "Neokitty (NKTT) | Игровой токен на Base"
      : lang === "zh"
      ? "Neokitty (NKTT) | Base 链上的游戏代币"
      : "Neokitty (NKTT) | Gaming Token on Base Chain";

  const seoDescription =
    lang === "en"
      ? "Neokitty (NKTT) is a gaming-focused crypto token built on Base chain. Explore tokenomics, roadmap, presale and the NKTT game ecosystem."
      : lang === "es"
      ? "Neokitty (NKTT) es un token cripto enfocado en gaming sobre Base chain. Descubre tokenomics, roadmap, preventa y el ecosistema de juego."
      : lang === "ru"
      ? "Neokitty (NKTT) — игровой крипто-токен на Base chain. Токеномика, дорожная карта, пресейл и игровая экосистема."
      : lang === "zh"
      ? "Neokitty (NKTT) 是构建在 Base 链上的游戏加密代币，包含代币经济、路线图、预售和游戏生态系统。"
      : "Neokitty (NKTT) is a gaming-focused crypto token built on Base chain.";

  return (
    <>
      <Helmet>
        <html lang={lang} />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <link rel="canonical" href="https://neokitty.io/" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-[#071029] via-[#071a3a] to-[#04233f] text-white antialiased">
        <LanguageSelector />


      <header className="max-w-6xl mx-auto px-6 py-6 flex items-center justify-between">
        <div className="flex items-center">
          <img
            src="/assets/logo-neokitty.png"
            alt="Neokitty Logo"
            className="w-[250px] h-[250px] object-contain drop-shadow-[0_0_12px_#00E6FF60]"
          />
        </div>

        <nav className="hidden md:flex items-center gap-10">
          <a href="#tokenomics" className={menuBtn}>
            {t("menu.tokenomics")}
          </a>
          <a href="#roadmap" className={menuBtn}>
            {t("menu.roadmap")}
          </a>
          <a href={gameHref} className={menuBtn}>
            {t("menu.game")}
          </a>
          <a href="/whitepaper" className={menuBtn}>
            {t("footer.whitepaper_title")}
          </a>
        </nav>

        <div className="hidden md:block">
          <a
            href="/buy"
            className="inline-flex items-center gap-2 bg-[#00E6FF] text-[#062034] px-6 py-3 rounded-xl font-bold shadow-[0_0_20px_#00E6FF70] hover:shadow-[0_0_28px_#00E6FF] hover:scale-[1.04] transition-all"
          >
            {t("menu.buy")}
          </a>
        </div>

        <button
          className="md:hidden p-2 border border-white/20 rounded-lg"
          onClick={() => setMenuOpen(true)}
        >
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path
              d="M4 7h16M4 12h16M4 17h16"
              stroke="#00E6FF"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>
      </header>

      {menuOpen && (
        <div className="fixed inset-0 z-50 bg-[#050b1d]/95 backdrop-blur px-6 py-8 flex flex-col">
          <div className="flex justify-between items-center mb-10">
            <span className="text-xl font-bold">Menu</span>
            <button onClick={() => setMenuOpen(false)}>
              <svg width="22" height="22" viewBox="0 0 24 24">
                <path
                  d="M6 6L18 18M6 18L18 6"
                  stroke="#00E6FF"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </div>

          <nav className="flex flex-col gap-6 text-lg font-semibold">
            <a href="#tokenomics" onClick={() => setMenuOpen(false)}>
              {t("menu.tokenomics")}
            </a>
            <a href="#roadmap" onClick={() => setMenuOpen(false)}>
              {t("menu.roadmap")}
            </a>
            <a href={gameHref} onClick={() => setMenuOpen(false)}>
              {t("menu.game")}
            </a>
            <a href="/whitepaper" onClick={() => setMenuOpen(false)}>
              {t("footer.whitepaper_title")}
            </a>
          </nav>

          <a
            href="/buy"
            className="mt-8 bg-[#00E6FF] text-[#062034] text-center py-3 rounded-xl font-bold"
          >
            {t("menu.buy")}
          </a>

          <div className="mt-10 border-t border-white/10 pt-6 flex flex-col gap-4 text-sm">
            <a href="mailto:neokitty.nktt@gmail.com">
              {t("footer.contact")}
            </a>
            <a href="/whitepaper">
              {t("footer.whitepaper_title")}
            </a>

            <div className="flex gap-4 mt-2">
              <a href="https://t.me/neokittynktt">
                <svg width="18" height="18" viewBox="0 0 24 24">
                  <path d="M2 12L22 4L15 22L11 14L2 12Z" fill="#00E6FF" />
                </svg>
              </a>
              <a href="https://instagram.com/neokitty.nktt">
                <svg width="18" height="18" viewBox="0 0 24 24">
                  <rect
                    x="3"
                    y="3"
                    width="18"
                    height="18"
                    rx="4"
                    stroke="#FF7A7A"
                    strokeWidth="1.4"
                    fill="none"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="3"
                    stroke="#FF7A7A"
                    strokeWidth="1.4"
                    fill="none"
                  />
                </svg>
              </a>
              <a href="https://twitter.com/neokittyNktt">
                <svg width="18" height="18" viewBox="0 0 24 24">
                  <path
                    d="M6 6 L18 18 M6 18 L18 6"
                    stroke="#00E6FF"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      )}

      <section className="max-w-6xl mx-auto px-6 py-12 lg:py-20 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div>
          <div className="inline-flex items-center gap-3 bg-white/5 px-3 py-1 rounded-full backdrop-blur shadow-[0_0_10px_#00E6FF40]">
            <span className="text-xs uppercase tracking-wide text-[#A7F0FF]">
              {t("hero.badge")}
            </span>
            <span className="text-xs text-slate-300">
              • {t("hero.presale_live_short")}
            </span>
          </div>

          <h1 className="mt-8 text-4xl md:text-5xl font-extrabold leading-tight drop-shadow-[0_0_12px_#00E6FF40]">
            {t("hero.title")}
          </h1>
<p className="sr-only">
  Neokitty (NKTT) is a gaming token built on Base chain, focused on Web3 gaming,
  on-chain rewards, decentralized game mechanics and blockchain-based gaming ecosystems.
</p>
          <p className="mt-5 text-slate-200 max-w-xl leading-relaxed">
            {t("hero.subtitle")}
          </p>

          <div className="mt-8 flex flex-wrap gap-4">
            <a
              href="/buy"
              className="inline-flex items-center gap-3 bg-[#00E6FF] text-[#012036] font-semibold px-5 py-3 rounded-lg shadow-[0_0_12px_#00E6FF80] hover:shadow-[0_0_20px_#00E6FF] hover:scale-[1.04] transition-all"
            >
              {t("hero.buy")}
            </a>

            <a
              href="#tokenomics"
              className="inline-flex items-center gap-2 border border-white/20 px-5 py-3 rounded-lg text-sm hover:bg-white/10 transition shadow-[0_0_8px_#00E6FF30]"
            >
              {t("hero.tokenomics")}
            </a>
          </div>

          <div className="mt-8 grid grid-cols-3 gap-4">
            <div className="bg-white/5 rounded-lg p-4 text-center shadow-[0_0_8px_#00E6FF20]">
              <div className="text-2xl font-bold">10B NKTT</div>
              <div className="text-xs text-slate-300 mt-1">
                {t("hero.supply")}
              </div>
            </div>

            <div className="bg-white/5 rounded-lg p-4 text-center shadow-[0_0_8px_#00E6FF20]">
              <div className="text-2xl font-bold">1% 🔥</div>
              <div className="text-xs text-slate-300 mt-1">
                {t("hero.burn")}
              </div>
            </div>

            <div className="bg-white/5 rounded-lg p-4 text-center shadow-[0_0_8px_#00E6FF20]">
              <div className="text-2xl font-bold">VRF</div>
              <div className="text-xs text-slate-300 mt-1">
                {t("hero.chainlink")}
              </div>
            </div>
          </div>
        </div>

        <div className="relative">
          <div className="rounded-3xl bg-[#041a30]/80 p-6 shadow-[0_0_25px_#00E6FF30] border border-white/10">
            <div className="flex items-center gap-4">
              <img
                src="/assets/coin-nktt.png"
                alt="NKTT Coin"
                className="w-20 h-20 drop-shadow-[0_0_15px_#00E6FF60]"
              />

              <div>
                <div className="text-sm text-slate-300">
                  {t("presale.price")}
                </div>
                <div className="mt-1 text-3xl font-extrabold">
                  0.000000015 ETH
                </div>
                <div className="text-xs text-slate-400 mt-2">
                  {t("presale.hardcap")}
                </div>
              </div>
            </div>

            <div className="mt-6">
              <div className="w-full bg-white/5 rounded-full h-3 overflow-hidden">
                <div
                  className="bg-gradient-to-r from-[#1EE0E9] to-[#8B7BFF] h-3"
                  style={{ width: `${presalePercent}%` }}
                />
              </div>
              <div className="mt-3 text-xs text-slate-400">
                {presalePercent}% {t("presale.progress")}
              </div>
            </div>

            <div className="mt-6 rounded-xl overflow-hidden border border-white/10 shadow-[0_0_12px_#00E6FF20]">
              <iframe
		loading="lazy"
                title="uniswap-token"
                src="https://app.uniswap.org/#/tokens/base/0xdBfCb6BE6E1E42ab18a1A09931F8F8DAD90F99EF"
                height="360"
                width="100%"
                style={{ border: "none", minHeight: 240 }}
              />
            </div>
          </div>
        </div>
      </section>
<section className="max-w-4xl mx-auto px-6 py-8">
  <h2 className="sr-only">
    What is Neokitty (NKTT)?
  </h2>

  <div className="sr-only">
    <p>
      Neokitty (NKTT) is a gaming-focused crypto token built on Base chain,
      designed to power a decentralized gaming ecosystem where players can
      participate, compete and earn on-chain rewards. The project combines
      Web3 technology with accessible game mechanics to create a transparent
      and engaging experience for both crypto-native users and newcomers.
    </p>

    <p className="mt-4">
      The NKTT token is used across the Neokitty ecosystem to enable gameplay
      interactions, reward distribution and future game-related utilities.
      With a fixed supply and a clear tokenomics model, Neokitty aims to build
      a sustainable gaming environment aligned with blockchain principles such
      as fairness, provable mechanics and decentralized ownership.
    </p>
  </div>
</section>

      <section id="buy" className="max-w-6xl mx-auto px-6 py-12">
        <div className="bg-[#06213a]/40 p-8 rounded-2xl flex flex-col md:flex-row items-center justify-between gap-6 shadow-[0_0_20px_#00E6FF20]">
          <div>
            <h3 className="text-2xl font-bold drop-shadow-[0_0_12px_#00E6FF40]">
              {t("cta.title")}
            </h3>
            <p className="text-slate-300 mt-2">
              {t("cta.desc")}
            </p>
          </div>

          <div className="flex gap-4 items-center">
            <a
              href="/buy"
              className="px-5 py-3 bg-[#00E6FF] text-[#022034] rounded-lg font-semibold shadow-[0_0_15px_#00E6FF70] hover:scale-[1.05] transition"
            >
              {t("cta.buy")}
            </a>

            <a href="https://t.me/neokittynktt">
              <svg width="20" height="20" viewBox="0 0 24 24">
                <path d="M2 12L22 4L15 22L11 14L2 12Z" fill="#00E6FF" />
              </svg>
            </a>

            <a href="https://instagram.com/neokitty.nktt">
              <svg width="20" height="20" viewBox="0 0 24 24">
                <rect
                  x="3"
                  y="3"
                  width="18"
                  height="18"
                  rx="4"
                  stroke="#FF7A7A"
                  strokeWidth="1.4"
                  fill="none"
                />
                <circle
                  cx="12"
                  cy="12"
                  r="3"
                  stroke="#FF7A7A"
                  strokeWidth="1.4"
                  fill="none"
                />
              </svg>
            </a>

            <a href="https://twitter.com/neokittyNktt">
              <svg width="20" height="20" viewBox="0 0 24 24">
                <path
                  d="M6 6 L18 18 M6 18 L18 6"
                  stroke="#00E6FF"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </a>
          </div>
        </div>
      </section>

      <section id="tokenomics" className="max-w-6xl mx-auto px-6 py-12">
        <h2 className="text-3xl font-bold mb-6">
          {t("tokenomics.title")}
        </h2>

        <div className="grid md:grid-cols-3 gap-6">
          <div className="bg-[#041a30]/60 p-6 rounded-2xl border border-white/10 shadow-[0_0_12px_#00E6FF20]">
            <h3 className="font-bold text-xl mb-3">
              {t("tokenomics.supply_title")}
            </h3>
            <p className="text-slate-300">10B NKTT</p>
          </div>

          <div className="bg-[#041a30]/60 p-6 rounded-2xl border border-white/10 shadow-[0_0_12px_#00E6FF20]">
            <h3 className="font-bold text-xl mb-3">
              {t("tokenomics.distribution_title")}
            </h3>
            <ul className="text-slate-300 text-sm space-y-1">
              <li>{t("tokenomics.dist.team")} — 10%</li>
              <li>{t("tokenomics.dist.presale")} — 40%</li>
              <li>{t("tokenomics.dist.liquidity")} — 30%</li>
              <li>{t("tokenomics.dist.gamerewards")} — 20%</li>
            </ul>
          </div>

          <div className="bg-[#041a30]/60 p-6 rounded-2xl border border-white/10 shadow-[0_0_12px_#00E6FF20]">
            <h3 className="font-bold text-xl mb-3">
              {t("tokenomics.taxes_title")}
            </h3>
            <p className="text-slate-300 text-sm leading-relaxed">
              🔥 1% {t("tokenomics.tax.burn")}
              <br />
              <span className="flex items-center gap-2 mt-1">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#00E6FF"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="4" width="18" height="14" rx="2" ry="2" />
                  <line x1="2" y1="20" x2="22" y2="20" />
                </svg>
                1% {t("tokenomics.tax.team")}
              </span>
            </p>
          </div>
        </div>
      </section>

      <section id="roadmap" className="max-w-6xl mx-auto px-6 py-12">
        <h2 className="text-3xl font-bold mb-6">
          {t("roadmap.title")}
        </h2>

        <div className="grid md:grid-cols-3 gap-6">
          <div className="bg-[#041a30]/60 p-6 rounded-2xl border border-white/10 shadow-[0_0_12px_#00E6FF20]">
            <h4 className="font-semibold mb-2">
              {t("roadmap.phase1.title")}
            </h4>
            <p className="text-slate-300 text-sm">
              {t("roadmap.phase1.desc")}
            </p>
          </div>

          <div className="bg-[#041a30]/60 p-6 rounded-2xl border border-white/10 shadow-[0_0_12px_#00E6FF20]">
            <h4 className="font-semibold mb-2">
              {t("roadmap.phase2.title")}
            </h4>
            <p className="text-slate-300 text-sm">
              {t("roadmap.phase2.desc")}
            </p>
          </div>

          <div className="bg-[#041a30]/60 p-6 rounded-2xl border border-white/10 shadow-[0_0_12px_#00E6FF20]">
            <h4 className="font-semibold mb-2">
              {t("roadmap.phase3.title")}
            </h4>
            <p className="text-slate-300 text-sm">
              {t("roadmap.phase3.desc")}
            </p>
          </div>
        </div>
      </section>

      <footer className="max-w-6xl mx-auto px-6 py-12 text-slate-300">
        <div className="border-t border-white/5 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-12">
          <div>
            <img
              src="/assets/logo-neokitty.png"
              alt="Neokitty"
              className="w-28 h-auto mb-3"
            />
            <div className="text-sm">
              © {new Date().getFullYear()} Neokitty
            </div>
            <div className="text-xs text-slate-400 mt-1">
              {t("footer.chain")}
            </div>
            <div className="text-xs text-slate-400">
              {t("footer.tagline")}
            </div>
          </div>

          <div className="hidden md:flex flex-row gap-16">
            <div>
              <div className="font-semibold mb-1">
                {t("footer.contact")}
              </div>
              <a
                href="mailto:neokitty.nktt@gmail.com"
                className="underline"
              >
                neokitty.nktt@gmail.com
              </a>
            </div>

            <div>
              <div className="font-semibold mb-1">
                {t("footer.whitepaper_title")}
              </div>
              <a href="/whitepaper" className="underline">
                {t("footer.whitepaper")}
              </a>
            </div>

            <div>
              <div className="font-semibold mb-1">
                {t("footer.community")}
              </div>
              <div className="flex flex-col mt-2 space-y-2">
                <a
                  href="https://t.me/neokittynktt"
                  className="flex items-center gap-2"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24">
                    <path
                      d="M2 12L22 4L15 22L11 14L2 12Z"
                      fill="#00E6FF"
                    />
                  </svg>
                  Telegram
                </a>

                <a
                  href="https://instagram.com/neokitty.nktt"
                  className="flex items-center gap-2"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24">
                    <rect
                      x="3"
                      y="3"
                      width="18"
                      height="18"
                      rx="4"
                      stroke="#FF7A7A"
                      strokeWidth="1.2"
                      fill="none"
                    />
                    <circle
                      cx="12"
                      cy="12"
                      r="3"
                      stroke="#FF7A7A"
                      strokeWidth="1.2"
                      fill="none"
                    />
                  </svg>
                  Instagram
                </a>

                <a
                  href="https://twitter.com/neokittyNktt"
                  className="flex items-center gap-2"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24">
                    <path
                      d="M6 6 L18 18 M6 18 L18 6"
                      stroke="#00E6FF"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                    />
                  </svg>
                  Twitter
                </a>
              </div>
            </div>
          </div>
        </div>
    </footer>
    </div>
  </>
);
}


